<template>
  <div>
    <ODialog ref="dialog" :maxWidth="1000">
      <v-card>
        <ODialogBar title="Selecione veículos" @close="dismiss" />

        <PanelMultiple
          class="maxh-5"
          strings="veículo;o"
          :items="allItems"
          v-model="copiedValue"
        />

        <ODialogButtons
          class="pa-6"
          txtApply="OK"
          @cancel="dismiss"
          @apply="apply"
        />
      </v-card>
    </ODialog>

    <!-- NB: BasePicker só emite input qdo clica no clear -->
    <BasePicker
      :label="label"
      strings="veículo;o"
      icon="mdi-car"
      :orientation="orientation"
      :whenEmpty="whenEmpty"
      :value="value"
      @input="clear"
      @open="openDialog"
    />
  </div>
</template>

<script>
import BasePicker from 'oderon-vue/cpts/pickers/BasePicker'
import PanelMultiple from 'oderon-vue/cpts/pickers/PanelMultiple.vue'
import { Vehicle } from '@/models'
import { orderBy } from 'oderon-commons/src/utils'

export default {
  components: {
    BasePicker,
    PanelMultiple
  },
  props: {
    label: { type: String, default: 'Veículo' },
    orientation: { type: String, default: 'horizontal' },
    value: {},
    whenEmpty: { type: String, default: '(Todos os veículos)' }
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: [],
      copiedValue: null
    }
  },
  methods: {
    async fetchData() {
      let rows = await Vehicle.findMini()
      this.allItems = orderBy(rows, [['code', 'asc']])
    },
    async openDialog() {
      this.copiedValue = JSON.parse(JSON.stringify(this.value))
      let res = await this.$refs.dialog.$open(this.value)
      if (res != null) {
        this.$emit('input', res)
      }
    },
    clear() {
      this.$emit('input', null)
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      this.$refs.dialog.$apply(this.copiedValue)
    }
  }
}
</script>

<style></style>
